export default __webpack_public_path__ + "static/media/assessment_white_icon.057d4225.svg";